
export default {
 name: 'MarqueeSlider',
 props: {
   blockOptions: {
     type: Object
   }
 }
}
